import { render, staticRenderFns } from "./ModalProcedimentosApenasHospitalDiaWarning.vue?vue&type=template&id=029351d2&scoped=true"
import script from "./ModalProcedimentosApenasHospitalDiaWarning.vue?vue&type=script&lang=ts"
export * from "./ModalProcedimentosApenasHospitalDiaWarning.vue?vue&type=script&lang=ts"
import style0 from "./ModalProcedimentosApenasHospitalDiaWarning.vue?vue&type=style&index=0&id=029351d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029351d2",
  null
  
)

export default component.exports